import { taskBuild } from '../behavior/taskBuild-sidecar'
import { taskConstructHull } from '../behavior/taskConstructHull-sidecar'
import { blueprints } from '../blueprints/blueprints-sidecar'
import { scene } from '../main/scene-sidecar'
import { tilesDataShip } from '../tiles/tilesDataShip-sidecar'
import { ITileShip } from '../tiles/tilesShip'
import { machinePlacer } from '../ui/machinePlacer-sidecar'
import { clickEater } from '../uiParts/clickEater-sidecar'
import { ITileMapShip } from '../tiles/tileMapShip'
import { tileMapShip } from '../tiles/tileMapShip-sidecar'
import { ITileDataShip } from '../tiles/tilesDataShip'

export function isHullBuildValid(
  t: ITileShip,
  map: ITileMapShip,
  tileData: ITileDataShip,
) {
  let std = tilesDataShip.getStandard()
  if (tileData === std.hull) {
    return isHullValid(t, map)
  }
  if (tileData === std.floor) {
    return isCorridorValid(t, map)
  }
  if (tileData === std.tube) {
    return isLadderValid(t, map)
  }
  return false
}

export function isLadderValid(t: ITileShip, map: ITileMapShip) {
  let std = tilesDataShip.getStandard()
  if (t.dataFloor !== std.hull && t.dataFloor !== std.floor) {
    return false
  }

  let check = (oi: number, oj: number) => {
    let tTest = tileMapShip.getTile(map, t.i + oi, t.j + oj)
    if (
      tTest &&
      (tTest.dataFloor === std.floor ||
        tTest.dataFloor === std.hull ||
        tTest.dataFloor === std.tube)
    ) {
      return true
    }

    return false
  }

  if (!check(0, -1)) {
    return false
  }
  if (!check(0, +1)) {
    return false
  }
  if (!check(+1, 0)) {
    return false
  }
  if (!check(-1, 0)) {
    return false
  }

  return true
}

export function isCorridorValid(t: ITileShip, map: ITileMapShip) {
  let std = tilesDataShip.getStandard()
  if (t.dataFloor !== std.hull && t.dataFloor !== std.tube) {
    return false
  }

  let check = (oi: number, oj: number) => {
    let tTest = tileMapShip.getTile(map, t.i + oi, t.j + oj)
    if (
      tTest &&
      (tTest.dataFloor === std.floor || tTest.dataFloor === std.hull)
    ) {
      return true
    }

    return false
  }

  let validCount = 0
  if (check(0, -1)) {
    validCount++
  }
  if (check(0, +1)) {
    validCount++
  }
  if (check(+1, 0)) {
    validCount++
  }
  if (check(-1, 0)) {
    validCount++
  }

  if (validCount === 4) {
    return true
  }

  return false
}

export function isHullValid(t: ITileShip, map: ITileMapShip) {
  let std = tilesDataShip.getStandard()
  if (t.dataFloor === std.floor) {
    return true
  }
  if (t.dataFloor !== null) {
    return false
  }

  let check = (oi: number, oj: number) => {
    let tTest = tileMapShip.getTile(map, t.i + oi, t.j + oj)
    if (
      tTest &&
      (tTest.dataFloor === std.floor || tTest.dataFloor === std.hull)
    ) {
      return true
    }

    let bp = blueprints.findAtSpot(
      t.i + oi,
      t.j + oj,
      (c) => c.data.type === 'construct-hull',
    )
    if (bp) {
      return true
    }

    return false
  }

  if (check(0, -1)) {
    return true
  }
  if (check(0, +1)) {
    return true
  }
  if (check(+1, 0)) {
    return true
  }
  if (check(-1, 0)) {
    return true
  }

  return false
}

export function run(t: ITileShip, isLeft: boolean, isGodMode: boolean) {
  let ms = clickEater.getMouseState()
  let ctx = scene.getContext()
  let std = tilesDataShip.getStandard()
  let current = blueprints.findAtSpot(
    t.i,
    t.j,
    (c) => c.data.type === 'construct-hull' || c.data.type === 'build',
  )
  if (ms.left) {
    // TODO: kill / toggle mode

    // if (current) {
    //   blueprints.kill(current)
    // }

    if (!current) {
      let cur = scene.getContext().cursor

      if (cur.tileData) {
        if (isGodMode) {
          taskConstructHull.forceConstructHull(t.i, t.j, cur.tileData)
        } else {
          if (isHullBuildValid(t, ctx.mapShip, cur.tileData)) {
            let bp = blueprints.create('construct-hull')
            blueprints.moveToTile(bp, ctx.mapShip, t.i, t.j)
            blueprints.setHullPart(bp, cur.tileData)
          }
        }
      }

      if (cur.machineData) {
        // is this valid?
        let isValid = machinePlacer.checkValid(t)
        if (isValid) {
          if (isGodMode) {
            taskBuild.forceBuildMachine(t.i, t.j, cur.machineData)
          } else {
            let bp = blueprints.create('build')
            blueprints.setMachine(bp, cur.machineData)
            blueprints.moveToTile(bp, ctx.mapShip, t.i, t.j)
          }
        }
      }

      // if (cur.cargoType) {
      //   if (t.dataFloor && t.dataFloor === std.floor) {
      //     if (godMode) {
      //       taskBuild.forceBuildStack(t.i, t.j, cur.cargoType)
      //     } else {
      //       // console.log('create machine bp!')
      //       let bp = blueprints.create('build')
      //       blueprints.moveToTile(bp, ctx.mapShip, t.i, t.j)
      //       blueprints.setStack(bp, cur.cargoType)
      //     }
      //   }
      // }
    }
  } else {
    if (ms.right) {
      if (current) {
        blueprints.kill(current)
      }
    }
  }
}
